import type { TFunction } from "i18next";
import { z } from "zod";

export const MAX_TOKENS = 1_000_000_000;
export const MAX_REASON_LENGTH = 500;

const errorKey = (key: string) => `captainBilling.editors.errors.${key}`;

export const tokensSchema = (t: TFunction) =>
  z
    .number()
    .nullable()
    .transform((value, ctx) => {
      if (value !== null) return value;
      ctx.addIssue({ code: "custom", message: t(errorKey("required")) });
      return z.NEVER;
    })
    .pipe(
      z
        .number()
        .int(t(errorKey("whole")))
        .refine((value) => Math.abs(value) <= MAX_TOKENS, t(errorKey("tooMany"))),
    );

export const capSchema = (t: TFunction) =>
  z.object({ tokens: tokensSchema(t).refine((value) => value >= 0, t(errorKey("notNegative"))) });

export const topUpSchema = (t: TFunction) =>
  z.object({ tokens: tokensSchema(t).refine((value) => value > 0, t(errorKey("notPositive"))) });

export const correctionSchema = (t: TFunction) =>
  z.object({
    tokens: tokensSchema(t).refine((value) => value > 0, t(errorKey("zero"))),
    reason: z
      .string()
      .trim()
      .min(1, t(errorKey("reasonRequired")))
      .max(MAX_REASON_LENGTH, t(errorKey("reasonTooLong"), { max: MAX_REASON_LENGTH })),
  });
